import { TranslationKeys } from "../contexts/TranslationKeys";
import { Translator } from "../contexts/translator";
import { SYSNAME_DEFAULT, SYSNAME_SYSTEM, SYSNAME_TEMPLATE, SYSNAME_TEMPLATE_DEFAULT } from "./preset-constants";

export const getPermissionTypes = (translator: Translator): { id: string, name: string }[]  => {
    return [
        {
            id: SYSNAME_DEFAULT,
            name: translator.byKey(TranslationKeys.userDefined)
        },
        {
            id: SYSNAME_TEMPLATE,
            name: translator.byKey(TranslationKeys.template)
        },
        {
            id: SYSNAME_TEMPLATE_DEFAULT,
            name: translator.byKey(TranslationKeys.templateDefault)
        },
        {
            id: SYSNAME_SYSTEM,
            name: translator.byKey(TranslationKeys.system)
        },
        {
            id: SYSNAME_DEFAULT,
            name: translator.byKey(TranslationKeys.default)
        }
    ];
}